export default {
  LOAD_USER_REQUEST_LIST_START: 'LoadUserRequestListStart',
  LOAD_USER_REQUEST_LIST_END: 'LoadUserRequestListEnd',
  TOGGLE_CONFIRM_DIALOG: 'ToggleConfirmDialog'
};